import React from 'react';
import {Props} from './Props';
import {formatTime, createValidDate} from '../../utils/DateUtil';

const TimeFormatted: React.FunctionComponent<Props> = ({dateTime}) => {
    const date = createValidDate(dateTime);
    if (!date) {
        return <>-</>;
    }

    const formatted = formatTime(date);
    return <span>{formatted}</span>;
};

export default TimeFormatted;
